export var getItemColor = function getItemColor(el, defaultTypeValues) {
  var type = el.type;
  var color = '';
  if (type && defaultTypeValues) {
    defaultTypeValues.forEach(function (el) {
      if (el.value === type[0]) {
        color = el.color;
      }
    });
  }
  return color;
};